import { error as errorEvent, ErrorPageType } from 'lib/trackingEvents';
import { ApiError } from 'lib/error';
import { usePageView } from 'data/tracking/usePageView';

export const getErrorDetail = (error: ApiError) =>
  error.message ? error.message : '';

export const useErrorPageView = (errorType: ErrorPageType, error: ApiError) => {
  usePageView(
    errorEvent.getPageView(errorType, error.code, getErrorDetail(error)),
  );
};
